import { LogoutButton } from './logout-button';
import styles from './header.module.scss';
import { Link } from 'react-router-dom';
import SminexText from './sminex-text';
import EventText from './event-text';
import { FC } from 'react';

export const Header: FC = () => {
  return (
    <nav className={styles.container}>
      <Link to="/" className={styles.logo}>
        <SminexText />
        {/* <SminexLogo  /> */}
        <EventText />
      </Link>

      <LogoutButton />
    </nav>
  );
};
